import { Route, Routes } from 'react-router';
import { useTexts } from '@/feature/lang';
import { NotFound } from '@/view/app/routing/NotFound';
import { rmsReportsPath } from '@/view/pathDefinitions';
import ReportPage from '@/view/rms/reports/ReportPage';
import { DocumentTitle } from '../app/routing/DocumentTitle';

export default function RmsRoutes() {
  const texts = useTexts();

  return (
    <Routes>
      <Route
        path={rmsReportsPath}
        element={
          <>
            <DocumentTitle title={texts.rms.reports.header} />
            <ReportPage />
          </>
        }
      />
      <Route
        path="*"
        element={
          <>
            <DocumentTitle title={texts.app.routing.notFound.title} />
            <NotFound />
          </>
        }
      />
    </Routes>
  );
}
